var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page21"},[_c('h2',{attrs:{"id":"title"}},[_vm._v("C端产品及服务—服务创造价值")]),_c('div',{staticClass:"content"},[_c('TwoflanksTree',{ref:"twoflanksTree",attrs:{"id":"twoflanksTree"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }